import React from "react";
import { Link } from "react-router-dom";
import { Star } from "lucide-react";
import api from "../lib/api";
import { usePublicData } from "../lib/publicData";

export const GOOGLE_BUSINESS_SEARCH_URL = 'https://www.google.com/search?q=Studio+Euclides+Ecublens';
export const SiteSettingsContext = React.createContext({});
export const SiteSettingsProvider = ({ children }) => {
  const initial = usePublicData();
  const [settings, setSettings] = React.useState(initial.settings || {});
  React.useEffect(() => { api.get('/site-settings').then(r => setSettings(r.data)).catch(() => {}); }, []);
  return <SiteSettingsContext.Provider value={settings}>{children}</SiteSettingsContext.Provider>;
};
export const SeasonalBanner = () => {
  const settings = React.useContext(SiteSettingsContext);
  if (!settings.christmas_banner || !settings.christmas_enabled) return null;
  return <Link to="/noel" data-testid="christmas-seasonal-banner" className="block bg-[#D6A86C] text-[#151515] text-center px-4 py-2 text-sm font-medium">
    Shooting de Noël – CHF {settings.christmas_price} <span aria-hidden="true">→</span>
  </Link>;
};
export const GoogleReviewButton = ({ id }) => {
  const settings = React.useContext(SiteSettingsContext);
  return <a href={settings.google_review_url || GOOGLE_BUSINESS_SEARCH_URL} target="_blank" rel="noopener noreferrer" data-testid={`${id}-google-review-link`}
    className="inline-flex items-center gap-2 border-b border-current pb-1 text-sm"><Star size={15} aria-hidden="true"/> {settings.google_review_url ? 'Laisser un avis sur Google' : 'Retrouvez-nous sur Google'}</a>;
};